// get video element id
var vidClip = document.getElementById("video");

if (vidClip) {
  // toggle button class when finished
  vidClip.onended = function () {
    $('.video-pause-btn, .video-play-btn').toggle();
  };
}

function playVid() {
  video.play();
}

function pauseVid() {
  video.pause();
}

setTimeout(function () {
  var bridgeElement = document.getElementById("inside-bridge");
  if (bridgeElement) {
    bridgeElement.title = "Website chat window";
  }
}, 5000);
